<h1 class="title">Gestion des groupes de diffusion - Consulter la liste des groupes de diffusion</h1>

<mat-card>
    <mat-card-content>
        <div class="table-header">
            <h2>Liste des groupes de diffusions</h2>
            <button (click)="openCreateDialog()" color="primary" mat-raised-button>
              <mat-icon>add</mat-icon>
              Créer un groupe de diffusion
            </button>
          </div>

          <mat-divider></mat-divider>

          <div class="mat-elevation-z8">
            <mat-table [dataSource]="dataSource" matSort>
      
              <ng-container matColumnDef="titre">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Groupe</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.titre}} </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="nmbr_utilisateurs">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre d'utilisateurs</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.nmbr_utilisateurs }}</mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="creation_datetime">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Date de création</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.creation_datetime | date:'dd/MM/yyyy' }}</mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon mat-icon-button (click)="openEditDialog(element)" aria-label="Modifier le groupe">edit</mat-icon>
                </mat-cell>
              </ng-container>

              <div class="no-data" *matNoDataRow>
                <b>Aucun groupe de diffusion</b>
              </div>
      
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" [class.inactif]="!row.actif"></mat-row>
      
            </mat-table>
      
            <mat-paginator [pageSizeOptions]="[10, 15, 20]"
                           aria-label="Select page of periodic elements"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
    </mat-card-content>
</mat-card>
